module.exports = __webpack_public_path__ + "img/8.029e7330.png";